import { useEffect } from "react";

function Chartbeat(props){


        const loadChartbeat = () => {
            var e = document.createElement('script');
            var n = document.getElementById('chartbeat');
            e.type = 'text/javascript';
            e.async = true;
            e.src = '//static.chartbeat.com/js/chartbeat.js';
            n.parentNode.insertBefore(e, n);
        }

        const chartbeat = () => {

            var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
            _sf_async_config.uid = 65720;
            _sf_async_config.domain = 'myjoyonline.com';
            _sf_async_config.flickerControl = false;
            _sf_async_config.useCanonical = true;
            _sf_async_config.useCanonicalDomain = true;
            if(props.page === "article"){
            _sf_async_config.sections = props.category;
            _sf_async_config.authors = props.author;
            }
            loadChartbeat();
        };

useEffect(()=>{

    chartbeat();
},[])

return null;
};

export default Chartbeat;